import { FilterFacets } from '@/study-search/domain';
import { ParameterType } from '@/study-search/enums';

import { IFaq } from '@/study-search/interfaces';
import { FaqFacetsHandler } from './FaqFacetsHandler';
import getters from '@/study-search/store/getters';
import { Filter } from '../filter';
import careerOptionsData from './data/career-options.json';

export class DisciplineFaqHandler extends FaqFacetsHandler {
	public static Invalidated: boolean = false;
	dataStorageKey = 'faqs/discipline';

	protected canHandle(): boolean {
		return this.indexableFilters.length >= 1 && this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES);
	}

	protected async handle(): Promise<IFaq[]> {
		const filterOption = this.getFilterOption(ParameterType.DISCIPLINES);

		if (!filterOption) {
			throw new Error('Filter option not found.');
		}

		const disciplineName = filterOption.optionTitle;
		const searchPageUrl = this.getSearchPageOnlineProgrammesUrl(`/${filterOption.optionPath}`);

		let onlineProgrammeCount: number, percentageOfOnlineStudies: string;
		const data = this.getFromDataStorage();

		if (!data || DisciplineFaqHandler.Invalidated) {
			const facetsWithDiscipline = await this.getFacetsForFilterCombination();

			onlineProgrammeCount = this.getOnlineProgrammeCount(facetsWithDiscipline);
			percentageOfOnlineStudies = this.getPercentageOfOnlineStudies(facetsWithDiscipline, onlineProgrammeCount);

			this.storeOnlineProgrammeData({ onlineProgrammeCount, percentageOfOnlineStudies });
			DisciplineFaqHandler.Invalidated = false;
		} else {
			onlineProgrammeCount = data.onlineProgrammeCount;
			percentageOfOnlineStudies = data.percentageOfOnlineStudies;
		}

		const faqs = [
			{
				question: `Can I get a Master's degree in ${disciplineName} online?`,
				answer: `<div>Yes, you can. There are <a href="${searchPageUrl}">${onlineProgrammeCount} online Master’s in ${disciplineName}</a>,
                representing ${percentageOfOnlineStudies}% of the country’s programmes listed on Mastersportal.</div>`
			}
		];

		const careerOptionsFaq = this.getCareerOptionsInHtml(Number(filterOption.optionValue), filterOption.optionPath);
		if (careerOptionsFaq) {
			faqs.push({
				question: `What can you do with a Master's in ${disciplineName}?`,
				answer: careerOptionsFaq
			});
		}

		return faqs;
	}

	protected async getFacetsForFilterCombination(): Promise<FilterFacets[]> {
		const filters = getters.getFilters();

		const filtersCopy = filters.map((_) => ({ ..._ })) as Filter[];
		filtersCopy.forEach((_) => {
			if (_.type !== ParameterType.DISCIPLINES) {
				_.values = [];
			}
		});

		const parameters = this.parameterService.getParameters(filtersCopy);

		const facetsResult = await this.getFacets(parameters);

		return facetsResult;
	}

	private getCareerOptionsInHtml(disciplineId: number, prettyPath: string): string | undefined {
		const careerOptions = careerOptionsData.find(
			(_) => _.discipline_id === disciplineId && _.discipline_id === disciplineId
		);

		if (!careerOptions || careerOptions.career_options === '') {
			return;
		}

		const hostName = this.getHostname();

		if (hostName) {
			const link = `${hostName}/disciplines/${careerOptions.discipline_id}/${prettyPath}.html`;
			return careerOptions.career_options.replace("href=''", `href='${link}'`);
		}

		return careerOptions.career_options.replace("href=''", `href='/'`);
	}
}
